import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import { useState, useEffect } from "react";

const LightBox = ({ openId, gallery, setImageId, setCurrentIndex, currentIndex }) => {
    const [index, setIndex] = useState(openId);

    useEffect(() => {
        setIndex(openId);
        setCurrentIndex(openId);
    }, [openId, setCurrentIndex]);

    if (openId === null || !gallery?.length) return null;

    const total = gallery.length;
    const nextIndex = (index + 1) % total;
    const prevIndex = (index + total - 1) % total;

    const handleMovePrev = () => {
        const newIndex = prevIndex;
        setIndex(newIndex);
        setCurrentIndex(newIndex);
    };

    const handleMoveNext = () => {
        const newIndex = nextIndex;
        setIndex(newIndex);
        setCurrentIndex(newIndex);
    };

    return (
        <Lightbox
            mainSrc={gallery?.[index]?.image_data?.url}
            nextSrc={gallery?.[nextIndex]?.image_data?.url}
            prevSrc={gallery?.[prevIndex]?.image_data?.url}
            onCloseRequest={() => setImageId(undefined)}
            onMovePrevRequest={handleMovePrev}
            onMoveNextRequest={handleMoveNext}
        />
    );
};

export default LightBox;
